<template>
    <div class="pa-5">
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Product code" | t }}</v-col>
            <v-col cols="6" class="col-item">
                {{ activeProduct.code ? activeProduct.code : "-" }}
            </v-col>
        </v-row>
        <div v-for="classificator in productClassificators" v-if="classificator.assigned_tab === 'codes'">
            <div v-for="cr in classificator.rows">
                <v-row v-if="cr.value_type === 'text' || cr.value_type === 'number'">
                    <v-col class="row-title col-item" cols="3">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ getRowValue(cr.id, classificator.classificator_type) }}
                    </v-col>
                </v-row>
                <v-row
                    v-else-if="
                        cr.value_type === 'boolean' && getRowValue(cr.id, classificator.classificator_type) === true
                    "
                >
                    <v-col class="row-title col-item" cols="5">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col class="col-item" cols="6">
                        <v-icon style="font-size: 20px">
                            fal fa-check
                        </v-icon>
                    </v-col>
                </v-row>
                <v-row v-else-if="cr.value_type === 'text_field'">
                    <v-col cols="12">
                        {{ getRowValue(cr.id, classificator.classificator_type) }}
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ClassificatorInput from "../../../components/classificator-input.vue";
import { userTranslationFunctions } from "../../../mixins/user-translation-functions";
export default {
    name: "codes-tab",
    components: {},
    mixins: [userTranslationFunctions],
    data() {
        return {
            data: {}
        };
    },
    mounted() {},
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productClassificators"])
    },
    methods: {
        getRowValue(cr_id) {
            if (this.activeProduct.data && this.activeProduct.data.product_code) {
                const classificatorItemData = this.activeProduct.data.product_code.filter(
                    p => p.classificator_row_id === cr_id
                );
                if (classificatorItemData && classificatorItemData[0]) return classificatorItemData[0].value;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
